import { useOverlay, Button, DialogOverlay, DialogOverlayActions, IconButton } from '@fs/zion-ui'
import { ContentDelete } from '@fs/zion-icon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { deleteArtifact } from '../../../services/artifactService'
import { getLastPathElement } from '../../../util/StringUtil'
import useNotifications from '../../../hooks/useNotifications'

export default function DeleteSelectedActionButton({ checkedArtifacts, setCheckedArtifacts, refetch }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const deleteSelectedArtifactsOverlay = useOverlay()

  const deleteSelectedOnSubmit = async () => {
    deleteSelectedArtifactsOverlay.close()
    const deleteArtifactResponses = await Promise.allSettled(
      checkedArtifacts.map((artifactId) => {
        return deleteArtifact(artifactId)
      })
    )
    const failedToDeleteArtifactIds = []
    deleteArtifactResponses.forEach((response) => {
      if (response.status === 'rejected') {
        const artifactId = parseInt(getLastPathElement(response.reason.config.url), 10)
        failedToDeleteArtifactIds.push(artifactId)
      }
    })
    refetch()
    if (deleteArtifactResponses.length === failedToDeleteArtifactIds.length) {
      error(t('artifacts.deleteSelectedAllFailed', 'Error deleting selected artifacts'))
    } else if (failedToDeleteArtifactIds.length > 0) {
      error(
        t(
          'artifacts.deleteSelectedSomeFailed',
          'Error deleting the following artifact IDs: { failedToDeleteArtifactIds }',
          {
            failedToDeleteArtifactIds: JSON.stringify(failedToDeleteArtifactIds),
          }
        )
      )
    } else {
      ok(t('artifacts.deleteSelectedSuccess', 'Deleted selected artifacts'))
    }
    setCheckedArtifacts((prev) => prev.filter((artifactId) => failedToDeleteArtifactIds.includes(artifactId)))
  }

  return (
    <>
      <IconButton
        title={t('action.deleteSelected', 'Delete Selected')}
        onClick={deleteSelectedArtifactsOverlay.handleClick}
        Icon={ContentDelete}
        color="red"
        emphasis="high"
      />
      <DialogOverlay title={t('action.deleteSelected', 'Delete Selected')} {...deleteSelectedArtifactsOverlay}>
        <div>
          {checkedArtifacts.length > 1
            ? t(
                'artifacts.deleteMulipleConfirmation',
                'Artifacts deleted by data admins cannot be restored. Are you sure you want to permanently delete these artifacts?'
              )
            : t(
                'artifacts.deleteConfirmation',
                'Artifacts deleted by data admins cannot be restored. Are you sure you want to permanently delete this artifact?'
              )}
        </div>
        <DialogOverlayActions>
          <Button onClick={deleteSelectedOnSubmit} emphasis="high">
            {t('action.submit', 'Submit')}
          </Button>
          <Button onClick={deleteSelectedArtifactsOverlay.close}>{t('action.cancel', 'Cancel')}</Button>
        </DialogOverlayActions>
      </DialogOverlay>
    </>
  )
}
